import owd from 'owd/owd';
import 'lib/jquery-cookie';

export default class CookiesInfo extends owd.Component {
	init() {
        this.buttonClose = this.$element.find('[data-cookies-close]');
        this.bind();
	}

	bind() {
        this.on('load', this.dom.$window, () => {
            if($.cookie('agree')) {
                this.$element.remove();
            } else {
                this.$element.css({
                    'display': 'flex'
                });
            }
        })

        this.on('click', this.buttonClose, () => {
            $.cookie('agree', 'true', {
                expries: 365
            });
            this.$element.fadeOut();
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('cookies-info', {
	component: CookiesInfo
});
